import { render, staticRenderFns } from "./ModalDataMonitor.vue?vue&type=template&id=81af161a&scoped=true"
import script from "./ModalDataMonitor.vue?vue&type=script&lang=js"
export * from "./ModalDataMonitor.vue?vue&type=script&lang=js"
import style0 from "./ModalDataMonitor.vue?vue&type=style&index=0&id=81af161a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81af161a",
  null
  
)

export default component.exports